import {
  SampleDataSubjectFormDataSchema,
  SampleFormDataSchema,
} from './SampleFormDataSchema';
import { SampleDataSubjectFormDataType, SampleFormDataType } from './types';
import { SampleValidFormDataSchema } from './SampleValidFormDataSchema';

export class SampleSchema {
  static parseFormData<Dto>(data: Dto): SampleFormDataType {
    return SampleFormDataSchema.parse({ samples: data });
  }

  static parseUploadedData<Dto>(data: Dto): SampleDataSubjectFormDataType[] {
    return SampleDataSubjectFormDataSchema.array().parse(data);
  }

  static validFormDataSchema = SampleValidFormDataSchema;
}
